import * as React from "react";
import { SVGProps } from "react";

interface PropTypes extends SVGProps<SVGSVGElement> {
	color?: string;
}

export const SmallDotSvg = (props: SVGProps<SVGSVGElement>) => {
	const { color = "#637381" } = props;
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={4}
			height={4}
			viewBox="0 0 4 4"
			fill="none"
			{...props}
		>
			<circle cx={2} cy={2} r={2} fill={color} />
		</svg>
	);
}
